import { useSearchParams } from "./useSearchParams";

const defaultField = "DATE";
const defaultOrder = "DESC";

const parseOrderParam = (orderParam?: string | string[] | null) => {
  if (!orderParam || typeof orderParam !== "string") {
    return { field: defaultField, order: defaultOrder };
  }

  const parts = orderParam.split("-");
  if (parts.length < 2) {
    return { field: defaultField, order: defaultOrder };
  }

  const order = parts.pop() || defaultOrder;
  const field = parts.join("-") || defaultField;

  return { field, order };
};

export const useOrderFieldsFromSlug = () => {
  const searchParams = useSearchParams();
  return parseOrderParam(searchParams.order);
};
